import React, { useEffect, useState } from 'react';
import { Typography, Table, Button, Modal, Form, Input, InputNumber, Switch, Space, message } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import api from '../api';

// Admin > Business Config > Campaign Updates Config (admin, qa_admin): the
// lists Campaign Updates pick from. For now, Sources. A source is never
// deleted: one made inactive is no longer offered, and updates that have it
// keep it. Listed in Order, then by name.

export default function CampaignUpdatesConfigPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);     // null | { source }
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const load = () => {
    setLoading(true);
    api.get('/api/campaign-update-sources', { params: { all: 1 } })
      .then((r) => setRows(r.data || []))
      .catch(() => message.error('Failed to load sources.'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const open = (source) => {
    form.resetFields();
    form.setFieldsValue(source ? { name: source.Name, sort_order: source.SortOrder } : { name: '' });
    setModal({ source });
  };
  const save = async () => {
    let v;
    try { v = await form.validateFields(); } catch { return; }
    setSaving(true);
    try {
      if (modal.source) await api.put(`/api/campaign-update-sources/${modal.source.ID}`, { name: v.name, sort_order: v.sort_order ?? 0 });
      else await api.post('/api/campaign-update-sources', { name: v.name });
      setModal(null);
      load();
    } catch (err) {
      message.error(err.response?.data?.error || 'Save failed.');
    } finally {
      setSaving(false);
    }
  };
  const toggle = (s) => api.put(`/api/campaign-update-sources/${s.ID}`, { is_active: !s.IsActive })
    .then(load).catch(() => message.error('Failed to update.'));

  return (
    <div>
      <Typography.Title level={4} style={{ marginTop: 0 }}>Campaign Updates Config</Typography.Title>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Typography.Title level={5} style={{ margin: 0 }}>Sources</Typography.Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => open(null)}>Add Source</Button>
      </div>
      <Table
        rowKey="ID" size="small" loading={loading} dataSource={rows} pagination={false}
        locale={{ emptyText: 'No sources yet.' }}
        columns={[
          { title: 'Order', dataIndex: 'SortOrder', key: 'SortOrder', width: 80, align: 'right' },
          { title: 'Name', dataIndex: 'Name', key: 'Name' },
          { title: 'Updates', dataIndex: 'UpdateCount', key: 'UpdateCount', width: 90, align: 'right' },
          { title: 'Active', dataIndex: 'IsActive', key: 'IsActive', width: 90,
            render: (v, s) => <Switch size="small" checked={!!v} onChange={() => toggle(s)} /> },
          { title: '', key: 'edit', width: 80, align: 'right',
            render: (_, s) => <Button size="small" icon={<EditOutlined />} onClick={() => open(s)}>Edit</Button> },
        ]}
      />

      <Modal maskClosable={false} title={modal?.source ? 'Edit Source' : 'Add Source'} open={!!modal} onOk={save}
        onCancel={() => setModal(null)} confirmLoading={saving} okText="Save" destroyOnClose>
        <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
          <Space align="start" size={12}>
            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Required' }]}>
              <Input maxLength={100} style={{ width: 300 }} />
            </Form.Item>
            {modal?.source && (
              <Form.Item name="sort_order" label="Order"><InputNumber precision={0} style={{ width: 90 }} /></Form.Item>
            )}
          </Space>
        </Form>
      </Modal>
    </div>
  );
}
